// extracted by mini-css-extract-plugin
export default {"loading-spinner":"PageContent_loading-spinner__ZOX6C","error-message":"PageContent_error-message__mcFWv"};